import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { clsx as R } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as f } from "react";
import { RocheUIIcon as m } from "../icon/roche-icon.js";
import s from "./roche-message.module.scss.js";
import { RocheUIMessageType as c } from "./roche-message.types.js";
const r = "24px", v = ({ type: o, message: a, size: i, showCloseButton: d, labels: e }) => {
  const [h, g] = f(!1), u = o === c.ERROR ? "alert" : "status", l = {
    [c.INFO]: "info",
    [c.ERROR]: "alert-error",
    [c.SUCCESS]: "alert-success"
  }, p = () => {
    g(!0);
  };
  return /* @__PURE__ */ n(
    "div",
    {
      className: R(
        s.message,
        s[`message--${o}`],
        i && s[`message--${i}`],
        h && s["message--closed"]
      ),
      role: u,
      children: [
        /* @__PURE__ */ n("div", { className: s.message__content, children: [
          /* @__PURE__ */ t(m, { icon: l[o], width: r, height: r, decorative: !0 }),
          /* @__PURE__ */ t("span", { className: "message__type", children: (e == null ? void 0 : e[`${o}Title`]) || o }),
          /* @__PURE__ */ t("p", { children: a })
        ] }),
        d && /* @__PURE__ */ t(
          "button",
          {
            className: s["message__close-button"],
            "aria-label": e == null ? void 0 : e.closeButton,
            onClick: p,
            type: "button",
            children: /* @__PURE__ */ t(m, { icon: "close", width: r, height: r, decorative: !0 })
          }
        )
      ]
    }
  );
};
export {
  v as RocheUIMessage
};
